export const byApplicable = (applicableTo) => (content) =>
  content.applicableTo.includes(applicableTo);
